/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  EnvironmentEntryInput,
  EnvironmentEntryInput$Outbound,
  EnvironmentEntryInput$outboundSchema,
} from "./environmententryinput.js";

export type UpdateEnvironmentRequestBody = {
  /**
   * The description of the environment
   */
  description?: string | undefined;
  /**
   * List of environment entry names to remove
   */
  entriesToRemove: Array<string>;
  /**
   * List of environment entries to update or create
   */
  entriesToUpdate: Array<EnvironmentEntryInput>;
  /**
   * The name of the environment
   */
  name?: string | undefined;
};

/** @internal */
export type UpdateEnvironmentRequestBody$Outbound = {
  description?: string | undefined;
  entries_to_remove: Array<string>;
  entries_to_update: Array<EnvironmentEntryInput$Outbound>;
  name?: string | undefined;
};

/** @internal */
export const UpdateEnvironmentRequestBody$outboundSchema: z.ZodMiniType<
  UpdateEnvironmentRequestBody$Outbound,
  UpdateEnvironmentRequestBody
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    entriesToRemove: z.array(z.string()),
    entriesToUpdate: z.array(EnvironmentEntryInput$outboundSchema),
    name: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      entriesToRemove: "entries_to_remove",
      entriesToUpdate: "entries_to_update",
    });
  }),
);

export function updateEnvironmentRequestBodyToJSON(
  updateEnvironmentRequestBody: UpdateEnvironmentRequestBody,
): string {
  return JSON.stringify(
    UpdateEnvironmentRequestBody$outboundSchema.parse(
      updateEnvironmentRequestBody,
    ),
  );
}
